import { useAppContext } from "hooks";
import type { CurrencyCode } from "@beautypie/core";

export const useCurrencyCode = (): CurrencyCode => {
  const context = useAppContext();
  return context.currency;
};
